export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";